import { TabsData, SubmitPayload } from './export-types';

// Action Types
export const OPEN_TABS_EXPORT = 'OPEN_TABS_EXPORT';
export const CLOSE_TABS_EXPORT = 'CLOSE_TABS_EXPORT';

export const LOAD_TABS_REQUEST = 'LOAD_TABS_REQUEST';
export const LOAD_TABS_SUCCESS = 'LOAD_TABS_SUCCESS';
export const LOAD_TABS_FAILURE = 'LOAD_TABS_FAILURE';

export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
export const SET_TOGGLE = 'SET_TOGGLE';

export const TOGGLE_ITEM = 'TOGGLE_ITEM';
export const SELECT_ALL_FOR_TAB = 'SELECT_ALL_FOR_TAB';
export const CLEAR_ALL_FOR_TAB = 'CLEAR_ALL_FOR_TAB';

export const SUBMIT_EXPORT_REQUEST = 'SUBMIT_EXPORT_REQUEST';
export const SUBMIT_EXPORT_SUCCESS = 'SUBMIT_EXPORT_SUCCESS';
export const SUBMIT_EXPORT_FAILURE = 'SUBMIT_EXPORT_FAILURE';

// Action Creators
export const openTabsExport = () => ({ type: OPEN_TABS_EXPORT } as const);
export const closeTabsExport = () => ({ type: CLOSE_TABS_EXPORT } as const);

export const loadTabsRequest = () => ({ type: LOAD_TABS_REQUEST } as const);
export const loadTabsSuccess = (data: TabsData) => ({ type: LOAD_TABS_SUCCESS, payload: data } as const);
export const loadTabsFailure = (error: string) => ({ type: LOAD_TABS_FAILURE, error } as const);

export const setActiveTab = (tabKey: string) => ({ type: SET_ACTIVE_TAB, payload: tabKey } as const);
export const setToggle = (val: 'Blank' | 'Existing') => ({ type: SET_TOGGLE, payload: val } as const);

export const toggleItem = (tabKey: string, item: string, checked: boolean) =>
  ({
    type: TOGGLE_ITEM,
    payload: { tabKey, item, checked },
  } as const);

export const selectAllForTab = (tabKey: string, checked: boolean) =>
  ({
    type: SELECT_ALL_FOR_TAB,
    payload: { tabKey, checked },
  } as const);

export const clearAllForTab = (tabKey: string) => ({ type: CLEAR_ALL_FOR_TAB, payload: tabKey } as const);

export const submitExportRequest = () => ({ type: SUBMIT_EXPORT_REQUEST } as const);
export const submitExportSuccess = () => ({ type: SUBMIT_EXPORT_SUCCESS } as const);
export const submitExportFailure = (error: string) => ({ type: SUBMIT_EXPORT_FAILURE, error } as const);

export type TabsExportAction =
  | ReturnType<typeof openTabsExport>
  | ReturnType<typeof closeTabsExport>
  | ReturnType<typeof loadTabsRequest>
  | ReturnType<typeof loadTabsSuccess>
  | ReturnType<typeof loadTabsFailure>
  | ReturnType<typeof setActiveTab>
  | ReturnType<typeof setSearch>
  | ReturnType<typeof setToggle>
  | ReturnType<typeof toggleItem>
  | ReturnType<typeof selectAllForTab>
  | ReturnType<typeof clearAllForTab>
  | ReturnType<typeof submitExportRequest>
  | ReturnType<typeof submitExportSuccess>
  | ReturnType<typeof submitExportFailure>;
